import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { EntryTypes } from "./entryType";
import { Modes } from "./mode";

export const responsibleProxy: FieldSchema = {
  name: "responsibleProxy",
  grid: {
    displayed: true,
    order: 17,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Proxy Equipment Responsible",
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
  validation: {
    required: {
      getter: ({ entryType }) => {
        return entryType === EntryTypes.CLUSTER
      },
      fields: ["entryType"],
    }
  }
};
